import { render, staticRenderFns } from "./block-documents-download.vue?vue&type=template&id=d935392e&lang=pug"
import script from "./block-documents-download.vue?vue&type=script&lang=js"
export * from "./block-documents-download.vue?vue&type=script&lang=js"
import style0 from "./block-documents-download.vue?vue&type=style&index=0&id=d935392e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports